import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import User from './User';
import Preferences from "./Preferences"
import AppSearchbar from '../containers/AppSearchbar';
import logo from '../components/logo.png';
import Breadcrumbs from './Breadcrumbs';
import { showPreferences } from "../actions/preferencesActions";

const styles = theme => ({
  root: {
    flexGrow: 1,
    position: 'sticky',
    backgroundColor: theme.palette.common.black,
    top: 0,
    zIndex: 500
  },
  flex: {
    flex: 1
  },
  logo: {
    color: theme.palette.common.white,
    fontWeight: 300,
    letterSpacing: 3,
    marginLeft: 20,
    marginRight: 40
  }
});

class Header extends Component {

  showPreferences = (dispatch) => () => {
    dispatch(showPreferences())
  }

  render() {
    const { dispatch, classes, userInfo, advertiser, order, placement, onSearchbarSelect, constants, preferences } = this.props;
    return (
      <div className={classes.root}>
        {preferences.visible && <Preferences /> }
        <AppBar position="relative">
          <Toolbar className={classes.root}>
            <Link to="/">
              <img src={logo} height={40} alt="Hearst Autos logo" />
            </Link>
            <div align="center" className={classes.flex}>
              <AppSearchbar
                onSelect={onSearchbarSelect}
              />
            </div>
            <div>
              <User userInfo={userInfo} constants={constants} onShowPreferences={this.showPreferences(dispatch)} />
            </div>
          </Toolbar>
        </AppBar>
        <Breadcrumbs placement={placement} order={order} advertiser={advertiser} />
      </div>
    );
  }
}

Header.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    preferences: state.preferencesRequest ||{}
  }
};

export default connect(mapStateToProps)(withStyles(styles)(Header));
